export interface LevelPlayStartHeadingProps {
  /** `null`/`undefined` = recurso sem mecânica de vidas — o trecho some. */
  hearts?: number | null
  challengeCount: number
}

/**
 * Título e texto de vidas/desafios da tela inicial do Level Play.
 * Compartilhado entre jornada e quiz — a lógica de pluralização já existia
 * duplicada nos dois `Initial`.
 */
export const LevelPlayStartHeading = ({
  hearts,
  challengeCount
}: LevelPlayStartHeadingProps) => (
  <div className="flex w-full max-w-[400px] flex-col items-center gap-2 text-center">
    <span className="block text-xl font-extrabold leading-tight text-[#1e2139]">
      Preparado?
    </span>
    <p className="m-0 text-sm font-medium leading-relaxed text-gray-700">
      {hearts != null ? (
        <>
          Você possui{' '}
          <span className="font-bold text-danger">
            {hearts} vida{hearts === 1 ? '' : 's'}
          </span>{' '}
          para completar{' '}
        </>
      ) : (
        'Complete '
      )}
      <span className="font-semibold text-gray-900">
        {challengeCount} desafio{challengeCount === 1 ? '' : 's'}
      </span>{' '}
      e {challengeCount === 1 ? 'pode' : 'alguns podem'} ter tempo, fique atento!
    </p>
  </div>
)
